export const milestoneBoardTypeConstants = [
  { name: "Milestone Based", value: "milestone_based" },
  { name: "Individual", value: "individual" },
];
